import AssistantChat from '@hellodarwin/app-features/lib/features/assistant/components/AssistantChat';
import Loading from '@hellodarwin/core/lib/components/loading';
import styled from 'styled-components';
import { useAppSelector } from '../../../../app/app-hooks';
import AssistantGrantCard from '../../../../components/assistant/assistant-grant-card';
import {
  selectCompany,
  selectProfile,
} from '../../../../features/api/slices/profile-slice';

const AssistantContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 900px;
  overflow: hidden;
`;

interface NoGinStepsAssistantProps {
  entityNameDisplay: string;
  formApplicationId: string;
}

const NoGinStepsAssistant = ({
  entityNameDisplay,
  formApplicationId,
}: NoGinStepsAssistantProps) => {
  const profile = useAppSelector(selectProfile);
  const company = useAppSelector(selectCompany);

  if (!profile?.contact_id) {
    return <Loading />;
  }

  return (
    <AssistantContainer>
      <AssistantChat
        conversationId={null}
        user={{
          id: profile.contact_id,
          name: profile.contact_name || company?.name || 'User',
        }}
        isBeta
        usageContext={{ grant_application_id: formApplicationId }}
        entityNameDisplay={entityNameDisplay}
        manageRouting={false}
        showSidebar={false}
        grantCardByIdCtor={(grantId) => (
          <AssistantGrantCard grantId={grantId} />
        )}
      />
    </AssistantContainer>
  );
};

export default NoGinStepsAssistant;
